"use client";

import { createContext, type ReactNode, useContext } from "react";

import type { GetSettingsQueryResult } from "@/sanity.types";

const SettingsContext = createContext<GetSettingsQueryResult | undefined>(
  undefined,
);

export function SettingsProvider({ children, value }: SettingsProviderProps) {
  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
}

export type SettingsProviderProps = {
  children: ReactNode;
  value: GetSettingsQueryResult | undefined;
};

export function useSettings(): GetSettingsQueryResult | undefined {
  return useContext(SettingsContext);
}
